<template>
	<v-container fluid>
		<PartnerEmailModal :show="partnerEmailModal.show" :partner="partnerEmailModal.partner"
						   :opportunity="partnerEmailModal.opportunity" @callback="partnerEmailModalCallback"/>
		<div>
			<Lightbox
				:visible="imageGalleryShow"
				:imgs="imageList"
				:index="index"
				@hide="closeImage"
			></Lightbox>
		</div>
		<div>
			<Lightbox
			:visible="watermarkedImageGalleryShow"
			:imgs="watermarkedImageList"
			:index="indexWatermarked"
			@hide="closeWatermarkedImage"
			></Lightbox>
		</div>
		<v-layout row wrap v-if="results == false">
			<v-flex sm8 md4 xs12 offset-sm2 offset-md4>
				<v-card class="pa-4">
					<v-card-text class="grey--text">
						<v-flex xs12>
							nema rezultata
						</v-flex>
						<v-layout text-xs-right>
							<v-flex xs12>
								<v-btn @click="back" color="grey lighten-1">{{ $t('buttons.back') }}
								</v-btn>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row wrap class="sticky-items">
			<v-flex xs1 text-xs-right v-if="results == true">
				<a :href="vtigerObject.opportunity.vtiger_link" target="_blank">
					<v-btn>
						<v-icon small>fa-external-link-alt</v-icon>&nbsp;{{ $t('buttons.vtigerLink') }}
					</v-btn>
				</a>
			</v-flex>
			<v-flex xs11 text-xs-right v-if="results == true">
				<v-btn @click="back">
					<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
				</v-btn>
				<v-btn @click="save">
					<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap v-if="results == true">
			<v-flex xs12>
				<v-tabs color="#fafafa" v-model="tabId">
					<v-tab>{{ $t('tabs.details') }}</v-tab>
					<v-tab>{{ $t('tabs.posts') }}</v-tab>
					<v-tab>{{ $t('tabs.ad') }}</v-tab>
					<v-tab>{{ $t('tabs.media') }}</v-tab>
					<v-tab>{{ $t('tabs.mediaWithLogo') }}</v-tab>
					<v-tab>{{ $t('tabs.features') }}</v-tab>
					<v-tab-item>
						<v-layout row wrap>
							<v-flex sm6 md4 xs12>
								<v-card class="mt-4">
									<v-card-text>
										{{ $t('labels.location') }}
										<v-layout row wrap>
											<v-flex xs12>
												<Dropdown
													v-model="opportunity.location_county_id"
													:ajax="true"
													:data="'counties'"
													:label="'* '+$t('fields.county')"
													:readonly="true"></Dropdown>
											</v-flex>
										</v-layout>
										<v-layout row wrap
												  v-if="showCityDropdown && opportunity.location_county_id !== null">
											<v-flex xs12>
												<Dropdown
													v-model="opportunity.location_city_id"
													:ajax="true"
													:data="'cities/'+opportunity.location_county_id"
													:label="'* '+$t('fields.city')"
													:readonly="true"></Dropdown>
											</v-flex>
										</v-layout>
										<v-layout row wrap
												  v-if="showLocationName && opportunity.location_city_id !== null">
											<v-flex xs12>
												<Autocomplete
													v-model="opportunity.location_name"
													:ajax="true"
													:data="'locations/'+opportunity.location_city_id"
													:label="'* '+$t('fields.neighbourhood')"
													:readonly="true"></Autocomplete>
											</v-flex>
										</v-layout>
									</v-card-text>
								</v-card>
							</v-flex>
						</v-layout>
					</v-tab-item>
					<v-tab-item>
						<v-layout row wrap pt-4>
							<v-flex md6 xs12 pa-1>
								<v-layout row wrap>
									<v-flex xs12>
										<v-icon>fa-building</v-icon>
										<span style="font-size: 18px; color:gray;">&nbsp;&nbsp;{{
												$t('labels.partners')
											}}</span>
									</v-flex>
									<v-flex xs12 text-xs-right pt-3>
										<v-btn @click="sendEmails" color="grey lighten-1">
											<v-icon small>fa-envelope
											</v-icon>&nbsp;&nbsp;{{ $t('buttons.emailPartners') }}
										</v-btn>
									</v-flex>
									<v-flex xs12>
										<table class="table">
											<tr>
												<th width="50px">
													&nbsp;
												</th>
												<th>
													{{ $t('fields.partner') }}
												</th>
												<th>
													{{ $t('fields.language') }}
												</th>
												<th style="text-align: center">
													{{ $t('fields.dateOfLastDownload') }}
												</th>
											</tr>
											<tr v-for="(item, key) in partners" :key="key">
												<td>
													<CheckBox v-model="item.selected" :simple="true"></CheckBox>
												</td>
												<td @click="editClick(item)">{{ item.username }}</td>
												<td @click="editClick(item)">{{ item.language }}</td>
												<td @click="editClick(item)" style="text-align: center">{{
														item.date
													}}
												</td>
											</tr>
										</table>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex md6 xs12 pa-1>
								<v-layout row wrap>
									<v-flex xs12>
										<v-icon>fa-sync-alt</v-icon>
										<span style="font-size: 18px; color:gray;">&nbsp;&nbsp;{{
												$t('labels.syncPortals')
											}}</span>
									</v-flex>
									<v-flex xs12 text-xs-right pt-3>
										<v-btn @click="portalDetails" color="grey lighten-1">
											<v-icon small>fa-table</v-icon>&nbsp;&nbsp;{{ $t('buttons.details') }}
										</v-btn>
										<!-- <v-btn @click="syncAllPortals" color="grey lighten-1">
											<v-icon small>fa-sync-alt</v-icon>&nbsp;&nbsp;{{ $t('buttons.syncAll') }}
										</v-btn> -->
									</v-flex>
									<v-flex xs12>
										<table class="table">
											<tr>
												<th>
													{{ $t('fields.publish') }}
												</th>
												<th>
													{{ $t('fields.website') }}
												</th>
												<th>
													{{ $t('fields.statusXml') }}
												</th>
												<th>
													{{ $t('fields.dateOfXml') }}
												</th>
												<th>
													{{ $t('fields.validate') }}
												</th>
											</tr>
											<tr v-for="(item, key) in automaticPortals"
												:key="'a'+key" :class="{'website-error' : item.status == 'Greška'}">
												<td>
													<CheckBox v-model="item.publish" :simple="true"></CheckBox>
												</td>
												<td>
													{{item.portal_name}}
												</td>
												<td>
													{{item.status}}

													<v-btn v-if="item.status=='Djelomično generirano'" small @click="showErrors(item.html_string)" icon slot="activator">
														<v-icon small>fa-info-circle</v-icon>
													</v-btn>
												</td>
												<td>
													{{item.publish_date}}
												</td>
												<td>
													<template>
													<v-btn small @click="validateOpportunity(item.opportunity_id, item.automatic_sync_id)" icon slot="activator">
														<v-icon small>fa-check</v-icon>
													</v-btn>
													</template>
												</td>
											</tr>
											<tr v-for="(item, key) in this.opportunity.manual_portals_display"
												:key="'c'+key" :class="{'website-error' : item.status == 'Greška'}">
												<td>
													<CheckBox v-model="item.published" :simple="true"></CheckBox>
												</td>
												<td>
													{{ item.manual_portal_name }}
												</td>
												<td>
													<InputField v-model="item.status"></InputField>
												</td>
												<td>
													<DatePicker v-model="item.date"></DatePicker>
												</td>
												<td>
												</td>
											</tr>
										</table>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12>
								<div style="min-height:60px;"></div>
							</v-flex>
						</v-layout>
					</v-tab-item>
					<v-tab-item>
						<v-layout row wrap>
							<v-flex md6 xs12>
								<v-card v-for="(item, key) in descriptions" :key="key"
										class="mt-4">
									<v-card-text>
										<div class="subheading mb-2"><b>{{ item.language.name }}
											{{ $t('labels.languageDescription') }}:</b></div>
										{{ $t('labels.title') }}
										<InputField
											v-model="item.title"
											:simple="true"></InputField>
										{{ $t('labels.description') }}
										<Editor
											:init="$tinymceInitSmall15"
											v-model="item.description"></Editor>
										{{ $t('labels.equipment') }}
										<Editor
											:init="$tinymceInitSmall15"
											v-model="item.equipment"></Editor>
										{{ $t('labels.locationDescription') }}
										<Editor
											:init="$tinymceInitReadOnly10"
											:disabled="true"
											v-model="item.location_description"></Editor>
										{{ $t('labels.additionalInformation') }}
										<Editor
											:init="$tinymceInitReadOnly"
											:disabled="true"
											v-model="item.additional_information"></Editor>
										{{ $t('labels.footerForWeb') }}
										<Editor
											:init="$tinymceInitSmall5"
											v-model="item.footer"></Editor>
									</v-card-text>
								</v-card>
							</v-flex>
							<v-flex md5 xs12 offset-md1>
								<v-card class="mt-4">
									<v-card-text>
										{{ $t('labels.advertisedPrice') }}
										<CurrencyField
											v-model="opportunity.price"
											:simple="true"
											:suffix="'EUR'"
											:readonly="true"></CurrencyField>
										<br><br>{{ $t('labels.webCategories') }}
										<CheckBox
											v-model="opportunity.web_highlighted"
											:label="$t('labels.prominentRealEstate')"
											:simple="true"></CheckBox>
										<CheckBox
											v-model="opportunity.web_special"
											:label="$t('labels.specialOffers')"
											:simple="true"></CheckBox>
										<CheckBox
											v-model="opportunity.web_lowered_prices"
											:label="$t('labels.reducedRealEstatePrices')"
											:simple="true"></CheckBox>
										<CheckBox
											v-model="opportunity.web_appartments_top"
											:label="$t('labels.topThreeApartments')"
											:simple="true"></CheckBox>
										<CheckBox
											v-model="opportunity.web_houses_top"
											:label="$t('labels.topThreeHouses')"
											:simple="true"></CheckBox>
										<CheckBox
											v-model="opportunity.web_lofts_top"
											:label="$t('labels.topThreeFlats')"
											:simple="true"></CheckBox>
										<CheckBox
											v-model="opportunity.web_lands_top"
											:label="$t('labels.topThreePlots')"
											:simple="true"></CheckBox>
										<CheckBox
											v-model="opportunity.web_new"
											:label="$t('labels.newRealEsateOffers')"
											:simple="true"></CheckBox>
									</v-card-text>
								</v-card>
							</v-flex>
						</v-layout>
					</v-tab-item>
					<v-tab-item>
						<v-flex xs12 mt-4>
							<v-layout row>
								<v-flex text-xs-right>
									<v-btn @click="loadImagesClick">
										{{ $t('buttons.copyImages') }}
									</v-btn>
								</v-flex>
							</v-layout>
							<div class="files-container">
								<div v-if="opportunity.photos <= 0" style="text-align:center; line-height:60px;">
									<span>{{ $t('labels.noFilesUploaded') }}</span>
								</div>
								<div v-for="(item, key) in opportunity.photos" :key="key" class="file-tile">
									<div class="tile-image" @click="openImage(key)">
										<v-img :src="item.link"/>
									</div>
									<div class="tile-text">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<span
												v-bind="attrs"
												v-on="on"
												>{{ item.name }}</span>
											</template>
											<span>{{ item.name }}</span>
										</v-tooltip>
									</div>
									<div class="tile-buttons">
										<v-btn v-if="key != 0" small @click="leftImage(key)" icon slot="activator">
											<v-icon>fa-arrow-left</v-icon>
										</v-btn>
										<v-btn small @click="deleteImage(key)" icon slot="activator">
											<v-icon>fa-trash</v-icon>
										</v-btn>
										<v-btn v-if="key < opportunity.photos.length - 1" small @click="rightImage(key)" icon slot="activator">
											<v-icon>fa-arrow-right</v-icon>
										</v-btn>
									</div>
								</div>
							</div>
						</v-flex>
						<v-flex xs12>
							<UploadMultipleOpportunity
								v-model="opportunity.photos"
								:label="$t('labels.uploadFiles')"
								:showList="false"
								:opportunity="opportunity.vtiger_id"
								accept="image/*"/>
					</v-flex>
					<v-flex xs8 v-for="(item, key) in languages" :key="key" pt-4>
						<v-layout row wrap>
							<v-flex xs9 pr-4>
								<InputField :label="item['label'] + ' ' + $t('labels.videoUrl')"
								v-model="opportunity.videos[key]"></InputField>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs8 v-if="videoLinks[key] != null">
								<template>
									<div id="app">
										<LazyYoutube
											ref="youtubeLazyVideo"
											:src="videoLinks[key]"
											max-width="720px"
											aspect-ratio="16:9"
											thumbnail-quality="standard"
										/>
									</div>
								</template>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs12 mt-4>
						<v-layout row>
								<v-flex text-xs-right>
									<v-btn @click="loadImagesClickWatermark">
										{{ $t('buttons.copyImages') }}
									</v-btn>
								</v-flex>
							</v-layout>
						<div class="files-container">
							<div v-if="opportunity.watermarked_photos <= 0" style="text-align:center; line-height:60px;">
								<span>{{ $t('labels.noFilesUploaded') }}</span>
							</div>
							<div v-for="(item, key) in opportunity.watermarked_photos" :key="key" class="file-tile">
								<div class="tile-image" @click="openWatermarkedImage(key)">
									<v-img :src="item.link"/>
								</div>
								<div class="tile-text">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<span
											v-bind="attrs"
											v-on="on"
											>{{ item.name }}</span>
										</template>
										<span>{{ item.name }}</span>
									</v-tooltip>
								</div>
								<div class="tile-buttons">
									<v-btn v-if="key != 0" small @click="leftWatermarkedImage(key)" icon slot="activator">
										<v-icon>fa-arrow-left</v-icon>
									</v-btn>
									<v-btn small @click="deleteWatermarkedImage(key)" icon slot="activator">
										<v-icon>fa-trash</v-icon>
									</v-btn>
									<v-btn v-if="key < opportunity.watermarked_photos.length - 1" small @click="rightWatermarkedImage(key)" icon slot="activator">
										<v-icon>fa-arrow-right</v-icon>
									</v-btn>
								</div>
							</div>
						</div>
					</v-flex>
					<v-flex xs12>
						<v-flex ml-2>
						Dozvoljen je upload .JPG slika. Maksimalan broj dozvoljenih slika je 24.
						</v-flex>
						<UploadMultipleOpportunity
								v-model="opportunity.watermarked_photos"
								:label="$t('labels.uploadFiles')"
								:showList="false"
								:opportunity="opportunity.vtiger_id"
								:accept="'.jpg, .jpeg'"/>
					</v-flex>

				</v-tab-item>
				<v-tab-item>
					<v-layout row wrap v-if="opportunityCategory == null">
						<v-card-text class="grey--text">
							<v-flex xs12>
								Za odabrani opportunity nije postavljena kategorija nekretnine
							</v-flex>
						</v-card-text>
					</v-layout>
					<v-layout row wrap v-if="opportunityCategory != null">
						<v-flex xs12>
							<v-card class="mt-4 pa-4">
								<div class="subheading mb-2"><b>{{$t('labels.realestateLocation')}}</b></div>
								<v-layout row>
									<v-flex text-xs-right>
										<v-btn @click="loadFeaturesClick">
											{{ $t('buttons.copyFeatures') }}
										</v-btn>
									</v-flex>
								</v-layout>
								<v-layout>
									<v-flex md6 xs12 pa-4>
										<div>
										<CheckBox
										v-model="opportunity.luxury"
										:simple="true"
										:label="$t('labels.luxury')"></CheckBox>
										</div>
										<div>
										<CheckBox
											v-model="opportunity.first_row"
											:simple="true"
											:label="$t('labels.first_row')"></CheckBox>
										</div>
										<div>
										<CheckBox
											v-model="opportunity.second_row"
											:simple="true"
											:label="$t('labels.second_row')"></CheckBox>
										</div>
										<div>
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.seaview')}}</span>
										<v-radio-group v-model="opportunity.seaview" row class="ma-0 pt-1" hide-details>
											<v-radio :label="'da'" :value="'da'"></v-radio>
											<v-radio :label="'djelomičan'" :value="'djelomičan'"></v-radio>
											<button class="clear-button" @click="clearSeaview">{{$t('buttons.clear')}}</button>
										</v-radio-group>
										</div>
										<div>
										<span style="display:inline-block; padding-top:10px; color:grey;"><span style="color:red;">*</span> {{$t('labels.sea_distance')}}</span>
										<InputField
											v-model="opportunity.sea_distance"
											:simple="true"
											:counter="50"></InputField>
										</div>
										<div>
										<span style="display:inline-block; padding-top:10px; color:grey;"><span style="color:red;">*</span> {{$t('labels.center_distance')}}</span>
										<InputField
											v-model="opportunity.center_distance"
											:simple="true"
											:counter="50"></InputField>
										</div>
										<div>
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.sea_approach')}}</span>
										<v-radio-group v-model="opportunity.sea_approach" row class="ma-0 pt-1" hide-details>
											<v-radio :label="'direktno'" :value="'direktno'"></v-radio>
											<v-radio :label="'zaobilazno'" :value="'zaobilazno'"></v-radio>
											<button class="clear-button" @click="clearApproach">{{$t('buttons.clear')}}</button>
										</v-radio-group>
										</div>
										<div>
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.latitude')}}</span>
										<InputField
											v-model="opportunity.latitude"
											:simple="true"
											:counter="50"></InputField>
										</div>
										<div>
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.longitude')}}</span>
										<InputField
											v-model="opportunity.longitude"
											:simple="true"
											:counter="50"></InputField>
										</div>
										<div>
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.indomioLocation')}}</span>
										<Dropdown
											v-model="opportunity.indomio_location"
											:ajax="true"
											:data="'indomio_locations'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div>
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.njuskaloLocation')}}</span>
										<Dropdown
											v-model="opportunity.njuskalo_location"
											:ajax="true"
											:data="'njuskalo_locations'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
									</v-flex>
									<v-flex md6 xs12 pa-4>
										<div>
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.orientation')}}</span>
										<v-checkbox
											v-model="opportunity.orientation"
											:value="'sjever'"
											:label="'sjever'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.orientation"
											:value="'jug'"
											:label="'jug'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.orientation"
											:value="'istok'"
											:label="'istok'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.orientation"
											:value="'zapad'"
											:label="'zapad'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<span style="display:inline-block; padding-top:10px; color:grey;"></span>
										</div>
										<div>
										<CheckBox
											v-model="opportunity.hidden_info"
											:simple="true"
											:label="$t('labels.hidden_info')"></CheckBox>
										</div>
										<div>
										<CheckBox
											v-model="opportunity.videocall"
											:simple="true"
											:label="$t('labels.videocall')"></CheckBox>
										</div>
										<div>
										<CheckBox
											v-model="opportunity.exchanges"
											:simple="true"
											:label="$t('labels.exchanges')"></CheckBox>
										</div>
									</v-flex>
								</v-layout>
							</v-card>
							<v-card class="mt-4 pa-4">
								<div class="subheading mb-2"><b>{{$t('labels.realestateBasicInfo')}}</b></div>
								<v-layout>
									<v-flex md6 xs12 pa-4>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F'">
										<span style="display:inline-block; padding-top:10px; color:grey;"><span style="color:red;">*</span> {{$t('labels.appartment_type')}}</span>
										<Dropdown
											v-model="opportunity.appartment_type"
											:ajax="true"
											:data="'opportunity-features/appartment_type'"
											:simple="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'H'">
										<span style="display:inline-block; padding-top:10px; color:grey;"><span style="color:red;">*</span> {{$t('labels.house_type')}}</span>
										<Dropdown
											v-model="opportunity.house_type"
											:ajax="true"
											:data="'opportunity-features/house_type'"
											:simple="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.space_purpose')}}</span>
										<Dropdown
											v-model="opportunity.space_purpose"
											:ajax="true"
											:data="'opportunity-features/space_purpose'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'L'">
										<span style="display:inline-block; padding-top:10px; color:grey;"><span style="color:red;">*</span> {{$t('labels.ground_type')}}</span>
										<Dropdown
											v-model="opportunity.ground_type"
											:ajax="true"
											:data="'opportunity-features/ground_type'"
											:simple="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F'">
										<span style="display:inline-block; padding-top:10px; color:grey;"><span style="color:red;">*</span> {{$t('labels.level_no')}}</span>
										<Dropdown
											v-model="opportunity.level_no"
											:ajax="true"
											:data="'opportunity-features/level_no'"
											:simple="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'H'">
										<span style="display:inline-block; padding-top:10px; color:grey;"><span style="color:red;">*</span> {{$t('labels.level_no')}}</span>
										<Dropdown
											v-model="opportunity.level_no_house"
											:ajax="true"
											:data="'opportunity-features/level_no_house'"
											:simple="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;"><span style="color:red;">*</span> {{$t('labels.position')}}</span>
										<Dropdown
											v-model="opportunity.position"
											:ajax="true"
											:data="'opportunity-features/position'"
											:simple="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'L'">
										<span style="display:inline-block; padding-top:10px; color:grey;"><span style="color:red;">*</span> {{$t('labels.ground_purpose')}}</span>
										<Dropdown
											v-model="opportunity.ground_purpose"
											:ajax="true"
											:data="'opportunity-features/ground_purpose'"
											:simple="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.rooms_no')}}</span>
										<InputField
											v-model="opportunity.rooms_no"
											:simple="true"
											:mask="'##'"></InputField>
										</div>
										<div v-if="opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.room_no')}}</span>
										<InputField
											v-model="opportunity.room_no"
											:simple="true"
											:mask="'##'"></InputField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.bathrooms_with_no')}}</span>
										<InputField
											v-model="opportunity.bathrooms_with_no"
											:simple="true"
											:mask="'#'"></InputField>
										</div>
										<div v-if="opportunityCategory == 'B' || opportunityCategory == 'L' || opportunityCategory == 'H'">
										<span v-if="opportunityCategory == 'L' || opportunityCategory == 'H'" style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.area')}}</span>
										<span v-else style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.areaBusiness')}}</span>
										<QuantityField
											v-model="opportunity.ground_area"
											:simple="true"></QuantityField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.bathrooms_without_no')}}</span>
										<InputField
											v-model="opportunity.bathrooms_without_no"
											:simple="true"
											:mask="'#'"></InputField>
										</div>
										<div v-if="opportunityCategory == 'L'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.ground_length')}}</span>
										<InputField
											v-model="opportunity.ground_length"
											:simple="true"
											:counter="50"></InputField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.toilet_no')}}</span>
										<InputField
											v-model="opportunity.toilet_no"
											:simple="true"
											:mask="'#'"></InputField>
										</div>
										<div v-if="opportunityCategory == 'L'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.ground_width')}}</span>
										<InputField
											v-model="opportunity.ground_width"
											:simple="true"
											:counter="50"></InputField>
										</div>
										<div v-if="opportunityCategory == 'H'">
										<span style="display:inline-block; padding-top:10px; color:grey;">* {{$t('labels.house_build_type')}}</span>
										<Dropdown
											v-model="opportunity.house_build_type"
											:ajax="true"
											:data="'opportunity-features/house_build_type'"
											:simple="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.floor')}}</span>
										<Dropdown
											v-model="opportunity.floor"
											:ajax="true"
											:data="'opportunity-features/floor'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.total_floors')}}</span>
										<InputField
											v-model="opportunity.total_floors"
											:simple="true"
											:mask="'##'"></InputField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.units_no')}}</span>
										<InputField
											v-model="opportunity.units_no"
											:simple="true"
											:mask="'##'"></InputField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.living_area')}}</span>
										<QuantityField
											v-model="opportunity.living_area"
											:simple="true"></QuantityField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.nett_area')}}</span>
										<QuantityField
											v-model="opportunity.nett_area"
											:simple="true"></QuantityField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.year_built')}}</span>
										<InputField
											v-model="opportunity.year_built"
											:simple="true"
											:mask="'####'"></InputField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.build_type')}}</span>
										<Dropdown
											v-model="opportunity.build_type"
											:ajax="true"
											:data="'opportunity-features/build_type'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.tifacade')}}</span>
										<Dropdown
											v-model="opportunity.tifacade"
											:ajax="true"
											:data="'opportunity-features/tifacade'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.facade_width')}}</span>
										<InputField
											v-model="opportunity.facade_width"
											:simple="true"
											:mask="'####'"></InputField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.roof_state')}}</span>
										<Dropdown
											v-model="opportunity.roof_state"
											:ajax="true"
											:data="'opportunity-features/roof_state'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.roof_type')}}</span>
										<Dropdown
											v-model="opportunity.roof_type"
											:ajax="true"
											:data="'opportunity-features/roof_type'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.roof_build_type')}}</span>
										<Dropdown
											v-model="opportunity.roof_build_type"
											:ajax="true"
											:data="'opportunity-features/roof_build_type'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.roof_isolation')}}</span>
										<Dropdown
											v-model="opportunity.roof_isolation"
											:ajax="true"
											:data="'opportunity-features/roof_isolation'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.windows_type')}}</span>
										<Dropdown
											v-model="opportunity.windows_type"
											:ajax="true"
											:data="'opportunity-features/windows_type'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.windows_equipment')}}</span>
										<v-checkbox
											v-model="opportunity.windows_equipment"
											:value="'rolete'"
											:label="'rolete'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.windows_equipment"
											:value="'el. rolete'"
											:label="'el. rolete'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.windows_equipment"
											:value="'grilje/škure'"
											:label="'grilje/škure'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.windows_equipment"
											:value="'brisolej'"
											:label="'brisolej'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.windows_equipment"
											:value="'komarnici'"
											:label="'komarnici'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.windows_equipment"
											:value="'troslojno staklo'"
											:label="'troslojno staklo'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
									</v-flex>
									<v-flex md6 xs12 pa-4>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.floors')}}</span>
										<v-checkbox
											v-model="opportunity.floors"
											:value="'parket'"
											:label="'parket'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.floors"
											:value="'pločice'"
											:label="'pločice'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.floors"
											:value="'laminat'"
											:label="'laminat'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.floors"
											:value="'kamen'"
											:label="'kamen'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.floors"
											:value="'ostalo'"
											:label="'ostalo'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div>
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.approach_material')}}</span>
										<Dropdown
											v-model="opportunity.approach_material"
											:ajax="true"
											:data="'opportunity-features/approach_material'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div>
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.approach_type')}}</span>
										<v-checkbox
											v-model="opportunity.approach_type"
											:value="'javni'"
											:label="'javni'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.approach_type"
											:value="'privatni'"
											:label="'privatni'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div v-if="opportunityCategory == 'L'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.infrastructure')}}</span>
										<v-checkbox
											v-model="opportunity.infrastructure"
											:value="'gradski plin'"
											:label="'gradski plin'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.infrastructure"
											:value="'gradski vodovod'"
											:label="'gradski vodovod'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.infrastructure"
											:value="'gradska kanalizacija'"
											:label="'gradska kanalizacija'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.infrastructure"
											:value="'struja'"
											:label="'struja'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div v-if="opportunityCategory == 'L'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.shape')}}</span>
										<InputField
											v-model="opportunity.shape"
											:simple="true"
											:counter="50"></InputField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.renovation_year')}}</span>
										<InputField
											v-model="opportunity.renovation_year"
											:simple="true"
											:mask="'####'"></InputField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.object_data')}}</span>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'novogradnja'"
											:label="'novogradnja'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'lift'"
											:label="'lift'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'teretni lift'"
											:label="'teretni lift'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.floors"
											:value="'pristup za osobe s invaliditetom'"
											:label="'pristup za osobe s invaliditetom'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'gradski plin'"
											:label="'gradski plin'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'gradski vodovod'"
											:label="'gradski vodovod'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'cisterna za vodu'"
											:label="'cisterna za vodu'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'bušotina'"
											:label="'bušotina'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'voda-vlastito brojilo'"
											:label="'voda-vlastito brojilo'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'struja-vlastito brojilo DA'"
											:label="'struja-vlastito brojilo DA'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'struja-vlastito brojilo NE'"
											:label="'struja-vlastito brojilo NE'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'telefon'"
											:label="'telefon'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'gradska kanalizacija'"
											:label="'gradska kanalizacija'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'biopročiščivać'"
											:label="'biopročiščivać'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.object_data"
											:value="'septička jama'"
											:label="'septička jama'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.septic_tank_volume')}}</span>
										<QuantityField
											v-model="opportunity.septic_tank_volume"
											:simple="true"></QuantityField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.septic_tank')}}</span>
										<InputField
											v-model="opportunity.septic_tank"
											:simple="true"
											:counter="50"></InputField>
										</div>
									</v-flex>
								</v-layout>
							</v-card>
							<v-card class="mt-4 pa-4">
								<div class="subheading mb-2"><b>{{$t('labels.realestateAdditionalInfo')}}</b></div>
								<v-layout>
									<v-flex md6 xs12 pa-4>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.heating')}}</span>
										<Dropdown
											v-model="opportunity.heating"
											:ajax="true"
											:data="'opportunity-features/heating'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'L'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.ground_permits_and_confirmations')}}</span>
										<v-checkbox
											v-model="opportunity.ground_permits_and_confirmations"
											:value="'vlasnički list'"
											:label="'vlasnički list'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.ground_permits_and_confirmations"
											:value="'građevinska dozvola'"
											:label="'građevinska dozvola'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.ground_permits_and_confirmations"
											:value="'idejni projekt'"
											:label="'idejni projekt'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.ground_permits_and_confirmations"
											:value="'lokacijska dozvola'"
											:label="'lokacijska dozvola'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.ground_permits_and_confirmations"
											:value="'glavni projekt'"
											:label="'glavni projekt'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.ground_permits_and_confirmations"
											:value="'plaćene komunalne i vodne naknade'"
											:label="'plaćene komunalne i vodne naknade'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<CheckBox
											v-model="opportunity.air_conditioning"
											:simple="true"
											:label="$t('labels.air_conditioning')"></CheckBox>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.energy_class')}}</span>
										<Dropdown
											v-model="opportunity.energy_class"
											:ajax="true"
											:data="'opportunity-features/energy_class'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.alternative_energy')}}</span>
										<v-checkbox
											v-model="opportunity.alternative_energy"
											:value="'solarni paneli'"
											:label="'solarni paneli'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.alternative_energy"
											:value="'toplinske pumpe/dizalice topline'"
											:label="'toplinske pumpe/dizalice topline'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.alternative_energy"
											:value="'kogeneracija'"
											:label="'kogeneracija'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.permits_and_confirmations')}}</span>
										<v-checkbox
											v-model="opportunity.permits_and_confirmations"
											:value="'vlasnički list'"
											:label="'vlasnički list'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.permits_and_confirmations"
											:value="'građevinska dozvola'"
											:label="'građevinska dozvola'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.permits_and_confirmations"
											:value="'uporabna dozvola'"
											:label="'uporabna dozvola'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.permits_and_confirmations"
											:value="'legalizacija'"
											:label="'legalizacija'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.permits_and_confirmations"
											:value="'uporabna 1968.g.'"
											:label="'uporabna 1968.g.'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.permits_and_confirmations"
											:value="'uvjerenje s katastra 1968.g.'"
											:label="'uvjerenje s katastra 1968.g.'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.permits_and_confirmations"
											:value="'idejni projekt'"
											:label="'idejni projekt'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.permits_and_confirmations"
											:value="'lokacijska informacija'"
											:label="'lokacijska informacija'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.lodge_terrace')}}</span>
										<v-checkbox
											v-model="opportunity.lodge_terrace"
											:value="'lođa/terasa'"
											:label="'lođa/terasa'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.lodge_terrace"
											:value="'lođa(loggia)'"
											:label="'lođa(loggia)'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.lodge_terrace"
											:value="'terasa'"
											:label="'terasa'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.lodge_terrace"
											:value="'nema ništa navedeno'"
											:label="'nema ništa navedeno'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' ||opportunityCategory ==  'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.furniture_state')}}</span>
										<v-checkbox
											v-model="opportunity.furniture_state"
											:value="'potpuno namješten'"
											:label="'potpuno namješten'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.furniture_state"
											:value="'djelomično namješten'"
											:label="'djelomično namješten'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.furniture_state"
											:value="'nenamješten'"
											:label="'nenamješten'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.furniture_state"
											:value="'roh-bau'"
											:label="'roh-bau'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.furniture_state"
											:value="'moderno namješteno'"
											:label="'moderno namješteno'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.furniture_state"
											:value="'za renoviranje'"
											:label="'za renoviranje'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.other_objects')}}</span>
										<v-checkbox
											v-model="opportunity.other_objects"
											:value="'dvorište/vrt'"
											:label="'dvorište/vrt'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.other_objects"
											:value="'podrum'"
											:label="'podrum'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.other_objects"
											:value="'spremište/šupa'"
											:label="'spremište/šupa'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.other_objects"
											:value="'roštilj'"
											:label="'roštilj'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.other_objects"
											:value="'zimski vrt'"
											:label="'zimski vrt'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.other_objects"
											:value="'bazen'"
											:label="'bazen'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.other_objects"
											:value="'vrtna kućica'"
											:label="'vrtna kućica'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.other_objects"
											:value="'masline'"
											:label="'masline'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.other_objects"
											:value="'stabla smokve'"
											:label="'stabla smokve'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.other_objects"
											:value="'vanjski tuš'"
											:label="'vanjski tuš'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.other_objects"
											:value="'navodnjavanje'"
											:label="'navodnjavanje'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.pool_details')}}</span>
										<v-checkbox
											v-model="opportunity.pool_details"
											:value="'grijanje'"
											:label="'grijanje'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.pool_details"
											:value="'skimmer'"
											:label="'skimmer'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.pool_details"
											:value="'preljevni'"
											:label="'preljevni'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.pool_details"
											:value="'protustrujno plivanje'"
											:label="'protustrujno plivanje'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.pool_details"
											:value="'keramika'"
											:label="'keramika'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.pool_details"
											:value="'folija'"
											:label="'folija'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.pool_details"
											:value="'pvc'"
											:label="'pvc'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.pool_details"
											:value="'inox'"
											:label="'inox'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.pool_details"
											:value="'mozaik'"
											:label="'mozaik'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.pool_details"
											:value="'montažni'"
											:label="'montažni'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.pool_size')}}</span>
										<QuantityField
											v-model="opportunity.pool_size"
											:simple="true"></QuantityField>
										</div>
									</v-flex>
									<v-flex md6 xs12 pa-4>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.parking_type')}}</span>
										<v-checkbox
											v-model="opportunity.parking_type"
											:value="'garaža'"
											:label="'garaža'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.parking_type"
											:value="'garažno mjesto'"
											:label="'garažno mjesto'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.parking_type"
											:value="'vanjsko natkriveno mjesto'"
											:label="'vanjsko natkriveno mjesto'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.parking_type"
											:value="'vanjsko ne-natkriveno mjesto'"
											:label="'vanjsko ne-natkriveno mjesto'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.parking_type"
											:value="'besplatni javni parking'"
											:label="'besplatni javni parking'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.parking_type"
											:value="'naplatni javni parking'"
											:label="'naplatni javni parking'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.parking_spaces')}}</span>
										<Dropdown
											v-model="opportunity.parking_spaces"
											:ajax="true"
											:data="'opportunity-features/parking_spaces'"
											:simple="true"
											:clearable="true"></Dropdown>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.functionalities')}}</span>
										<v-checkbox
											 v-if="opportunityCategory == 'A' || opportunityCategory == 'F'"
											v-model="opportunity.functionalities"
											:value="'penthouse'"
											:label="'penthouse'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'zasebni ulaz u objekt'"
											:label="'zasebni ulaz u objekt'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'protuprovalna vrata'"
											:label="'protuprovalna vrata'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'protupožarna vrata'"
											:label="'protupožarna vrata'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'alarmni sustav'"
											:label="'alarmni sustav'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'video portafon'"
											:label="'video portafon'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'video nadzor'"
											:label="'video nadzor'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'kada'"
											:label="'kada'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'tuš kabina'"
											:label="'tuš kabina'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'jacuzzi'"
											:label="'jacuzzi'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'podno grijanje'"
											:label="'podno grijanje'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'kamin'"
											:label="'kamin'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'dimnjak'"
											:label="'dimnjak'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'sauna'"
											:label="'sauna'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'perilica posuđa'"
											:label="'perilica posuđa'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'vez za brod'"
											:label="'vez za brod'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'internet'"
											:label="'internet'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										<v-checkbox
											v-model="opportunity.functionalities"
											:value="'dalmatinski stil'"
											:label="'dalmatinski stil'"
											class="ma-0 pt-1"
											hide-details></v-checkbox>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.tourism_income')}}</span>
										<InputField
											v-model="opportunity.tourism_income"
											:simple="true"
											:counter="200"></InputField>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<CheckBox
											class = "pt-2"
											v-model="opportunity.reserve"
											:simple="true"
											:label="$t('labels.reserve')"></CheckBox>
										</div>
										<div v-if="opportunityCategory == 'A' || opportunityCategory == 'F' || opportunityCategory == 'H' || opportunityCategory == 'B'">
										<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.reserve_amount')}}</span>
										<QuantityField
											v-model="opportunity.reserve_amount"
											:simple="true"></QuantityField>
										</div>
										<div>
											<span style="display:inline-block; padding-top:10px; color:grey;">{{$t('labels.additional_info')}}</span>
											<TextArea
												v-model="opportunity.additional_info"></TextArea>
										</div>
									</v-flex>
								</v-layout>
							</v-card>
						</v-flex>
					</v-layout>
				</v-tab-item>
			</v-tabs>
			</v-flex>
		</v-layout>
		<v-dialog v-model="loadImagesShow" :persistent="false" max-width="500">
			<v-card class="load-images-popup">
				<v-card-text style="padding-bottom:100px">
					{{$t('fields.vtigerId')}}
					<Dropdown
						v-model="opportunitiesWithImages"
						:ajax="true"
						:data="'opportunities-with-images'"
						:simple="true"></Dropdown>
				</v-card-text>
				<v-spacer></v-spacer>
				<v-card-actions>
					<v-layout row fill-width>
						<v-btn @click="loadImagesSave">
							{{$t('buttons.load')}}
						</v-btn>
						<v-spacer>
						</v-spacer>
						<v-btn @click="loadImagesClose">
							{{$t('buttons.cancel')}}
						</v-btn>
					</v-layout>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="loadImagesShowWatermark" :persistent="false" max-width="500">
			<v-card class="load-images-popup">
				<v-card-text style="padding-bottom:100px">
					{{$t('fields.vtigerId')}}
					<Dropdown
						v-model="opportunitiesWithImagesWatermark"
						:ajax="true"
						:data="'opportunities-with-images-watermark'"
						:simple="true"></Dropdown>
				</v-card-text>
				<v-spacer></v-spacer>
				<v-card-actions>
					<v-layout row fill-width>
						<v-btn @click="loadImagesSaveWatermark">
							{{$t('buttons.load')}}
						</v-btn>
						<v-spacer>
						</v-spacer>
						<v-btn @click="loadImagesCloseWatermark">
							{{$t('buttons.cancel')}}
						</v-btn>
					</v-layout>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="loadFeaturesShow" :persistent="false" max-width="500">
			<v-card class="load-features-popup">
				<v-card-text style="padding-bottom:100px">
					{{$t('fields.vtigerId')}}
					<div v-if="opportunityCategory !== null && opportunityCategory !== undefined && opportunityCategory !== ''">
					<Dropdown
						v-model="opportunitiesWithFeatures"
						:ajax="true"
						:data="'opportunities-by-type/' + opportunityCategory"
						:simple="true"></Dropdown>
						</div>
				</v-card-text>
				<v-spacer></v-spacer>
				<v-card-actions>
					<v-layout row fill-width>
						<v-btn @click="loadFeaturesSave">
							{{$t('buttons.load')}}
						</v-btn>
						<v-spacer>
						</v-spacer>
						<v-btn @click="loadFeaturesClose">
							{{$t('buttons.cancel')}}
						</v-btn>
					</v-layout>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import CheckBox from "./trinkets/CheckBox";
import InputField from "./trinkets/InputField";
import UploadMultiple from "./trinkets/UploadMultiple";
import UploadMultipleOpportunity from "./trinkets/UploadMultipleOpportunity";
import CurrencyField from './trinkets/CurrencyField.vue';
import Autocomplete from "./trinkets/Autocomplete";
import Dropdown from "./trinkets/Dropdown";
import Opportunity from "../models/Opportunity";
import {LazyYoutube} from "vue-lazytube";
import Lightbox from 'vue-easy-lightbox';
import DropdownMultiple from "./trinkets/DropdownMultiple";
import TextArea from "./trinkets/TextArea";
import DatePicker from './trinkets/DatePicker';
import QuantityField from './trinkets/QuantityField';
import PartnerEmailModal from "./PartnerEmailModal";

export default {
	name: 'App',
	components: {
		PartnerEmailModal,
		CheckBox,
		InputField,
		Editor,
		CurrencyField,
		UploadMultiple,
		Autocomplete,
		Dropdown,
		LazyYoutube,
		Lightbox,
		DropdownMultiple,
		TextArea,
		DatePicker,
		QuantityField,
		UploadMultipleOpportunity
	},
	data() {
		return {
			tabId: 0,
			results: null,
			initialLoad: false,
			languages: [],
			descriptions: [],
			publicPath: process.env.BASE_URL,
			opportunity: new Opportunity({}),
			showCityDropdown: true,
			showLocationName: true,
			partners: [],
			automaticPortals: [],
			websites: {
				1: {
					name: 'portal 1',
					status: 'Zadnja uspješna sinkronizacija',
					date: new Date().toISOString().slice(0, 10),
					selected: false
				},
				2: {
					name: 'portal 2',
					status: 'Greška',
					date: new Date().toISOString().slice(0, 10),
					selected: false
				},
				3: {
					name: 'portal 3',
					status: 'Zadnja uspješna sinkronizacija',
					date: new Date().toISOString().slice(0, 10),
					selected: false
				}
			},
			videoLinks: [],
			vtigerObject: '',
			emailRecipients: [],
			imageGalleryShow: false,
			watermarkedImageGalleryShow: false,
			index: 0,
			indexWatermarked: 0,
			imageList: [],
			watermarkedImageList: [],
			opportunityCategory: null,
			validatedList: [],
			partnerEmailModal: {
				show: false,
				partner: null,
				opportunity: null
			},
			currentPartnerIndex: null,
			hasErrors: false,
			htmlString: '',
			photosChanged: false,
			loadImagesShow: false,
			loadImagesShowWatermark: false,
			loadFeaturesShow: false,
			opportunitiesWithImages: null,
			opportunitiesWithImagesWatermark: null,
			opportunitiesWithFeatures: null,
			opportunitiesWithFeaturesByType: [],
			imagesLoaded: null,
			imagesLoadedWatermark: null,
		}
	},
	watch: {
		opportunity: {
			handler: function () {
				if (this.initialLoad) {
					this.changesHappened = true;
				}
			},
			deep: true
		},
		"opportunity.location_county_id": {
			handler: function () {
				this.showCityDropdown = false;
				if (this.initialLoad) {
					this.opportunity.location_city_id = null;
				}
				this.$nextTick(() => {
					this.showCityDropdown = true;
				});
			},
			deep: true
		},
		"opportunity.location_city_id": {
			handler: function () {
				this.showLocationName = false;
				if (this.initialLoad) {
					this.opportunity.location_name = '';
				}
				this.$nextTick(() => {
					this.showLocationName = true;
				});
			},
			deep: true
		},
		"opportunity.videos": {
			handler: function () {
				this.videoLinks = [];
				for (const element of this.opportunity.videos) {
					if (element != null) {
						let regExp = /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
						let match = element.match(regExp);
						if (match) {
							this.videoLinks.push(element);
						} else {
							this.videoLinks.push(null);
						}
					}
				}
			}
		},
		"opportunity.photos":{
			handler: function() {
				if (this.initialLoad) {
					this.photosChanged = true;
				}
				this.imageList = [];
				for (const element of this.opportunity.photos){
					if(element != null){
						this.imageList.push(element.link);
					}
				}
			},
			deep: true
		},
		"opportunity.watermarked_photos":{
			handler: function() {
				if (this.initialLoad) {
					this.photosChanged = true;
				}
				this.watermarkedImageList = [];
				for (const element of this.opportunity.watermarked_photos){
					if(element != null){
						this.watermarkedImageList.push(element.link);
					}
				}
			},
			deep: true
		}
	},
	computed: {},
	methods: {
		clearSeaview(){
			this.opportunity.seaview = '';
		},
		clearApproach(){
			this.opportunity.sea_approach = '';
		},
		loadPartnerIntoModal() {
			let partner = this.partners[this.currentPartnerIndex];
			this.partnerEmailModal.partner = partner.id;
			this.partnerEmailModal.opportunity = this.opportunity.id;
			this.$nextTick(() => {
				this.partnerEmailModal.show = true;
			});
		},
		partnerEmailModalCallback() {
			this.partnerEmailModal.show = false;
			this.partnerEmailModal.partner = null;
			this.partnerEmailModal.opportunity = null;

			this.currentPartnerIndex++;
			if (this.currentPartnerIndex == this.partners.length) {
				this.currentPartnerIndex = null;
				return;
			}
			while(!this.partners[this.currentPartnerIndex].selected) {
				this.currentPartnerIndex++;
				if (this.currentPartnerIndex == this.partners.length) {
					this.currentPartnerIndex = null;
					return;
				}
			}

			this.$nextTick(() => {
				this.loadPartnerIntoModal();
			});
		},
		empty() {

		},
		portalDetails() {
			this.$router.push('/automatic-portals');
		},
		sendEmails() {
			for (const index in this.partners) {
				let partner = this.partners[index];
				if (partner.selected == true) {
					this.currentPartnerIndex = index;
					this.loadPartnerIntoModal();
					return;
				}
			}
			this.$alert(this.$t('alerts.noPartnersSelected'));
		},
		editClick(item) {
			item.selected = !item.selected;
		},
		back() {
			if (this.initialLoad) {
				this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
					if (result) {
						this.$router.push('/opportunities/');
					}
				});
			} else {
				this.$router.go(-1);
			}
		},
		save() {
			this.validatedList = [];
			let success = true;
			if (this.opportunityCategory == 'A' || this.opportunityCategory == 'F') {
				if (this.opportunity.sea_distance == '' || this.opportunity.sea_distance == null) {
					success = false;
					this.validatedList.push('Udaljenost od mora');
				}
				if (this.opportunity.center_distance == '' || this.opportunity.center_distance == null) {
					success = false;
					this.validatedList.push('Udaljenost od centra');
				}
				if (this.opportunity.appartment_type == '' || this.opportunity.appartment_type == null) {
					success = false;
					this.validatedList.push('Tip stana');
				}
				if (this.opportunity.level_no == '' || this.opportunity.level_no == null) {
					success = false;
					this.validatedList.push('Broj etaža');
				}
			}
			if (this.opportunityCategory == 'B') {
				if (this.opportunity.sea_distance == '' || this.opportunity.sea_distance == null) {
					success = false;
					this.validatedList.push('Udaljenost od mora');
				}
				if (this.opportunity.center_distance == '' || this.opportunity.center_distance == null) {
					success = false;
					this.validatedList.push('Udaljenost od centra');
				}
				if (this.opportunity.position == '' || this.opportunity.position == null) {
					success = false;
					this.validatedList.push('Pozicija');
				}
			}
			if (this.opportunityCategory == 'H') {
				if (this.opportunity.sea_distance == '' || this.opportunity.sea_distance == null) {
					success = false;
					this.validatedList.push('Udaljenost od mora');
				}
				if (this.opportunity.center_distance == '' || this.opportunity.center_distance == null) {
					success = false;
					this.validatedList.push('Udaljenost od centra');
				}
				if (this.opportunity.house_type == '' || this.opportunity.house_type == null) {
					success = false;
					this.validatedList.push('Tip kuće');
				}
				if (this.opportunity.level_no_house == '' || this.opportunity.level_no_house == null) {
					success = false;
					this.validatedList.push('Broj etaža');
				}
				if (this.opportunity.house_build_type == '' || this.opportunity.house_build_type == null) {
					success = false;
					this.validatedList.push('Vrsta kuće (gradnja)');
				}
			}
			if (this.opportunityCategory == 'L') {
				if (this.opportunity.sea_distance == '' || this.opportunity.sea_distance == null) {
					success = false;
					this.validatedList.push('Udaljenost od mora');
				}
				if (this.opportunity.center_distance == '' || this.opportunity.center_distance == null) {
					success = false;
					this.validatedList.push('Udaljenost od centra');
				}
				if (this.opportunity.ground_type == '' || this.opportunity.ground_type == null) {
					success = false;
					this.validatedList.push('Tip zemljišta');
				}
				if (this.opportunity.ground_purpose == '' || this.opportunity.ground_purpose == null) {
					success = false;
					this.validatedList.push('Namjena');
				}
			}
			if (success) {
				let vm = this;
				let data = {
					descriptions: this.descriptions,
					opportunity: this.opportunity,
					partners: this.partners,
					automaticPortals: this.automaticPortals,
					manualPortals: this.opportunity.manual_portals_display,
					photosChanged: this.photosChanged,
					imagesLoaded: this.imagesLoaded,
					imagesLoadedWatermark: this.imagesLoadedWatermark,
				}
				this.$APICall('put', 'opportunities/' + this.$route.params.id, data, (data, success) => {
					if (success) {
						vm.$notify(vm.$t('alerts.basicUpdate'));
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			} else {
				this.tabId = 5;
				let alertText = 'Sljedeća obavezna polja nisu ispunjena: <br><br>';
				for (const element of this.validatedList) {
					alertText += element + '<br>';
				}
				alertText += '<br> Jeste li sigurni da želite spremiti bez obaveznih polja?';
				this.$verify((alertText), (result) => {
					if (result) {
						let vm = this;
						let data = {
							descriptions: this.descriptions,
							opportunity: this.opportunity,
							partners: this.partners,
							automaticPortals: this.automaticPortals,
							manualPortals: this.opportunity.manual_portals_display,
							photosChanged: this.photosChanged,
							imagesLoaded: this.imagesLoaded,
							imagesLoadedWatermark: this.imagesLoadedWatermark,
						}
						this.$APICall('put', 'opportunities/' + this.$route.params.id, data, (data, success) => {
							if (success) {
								vm.$notify(vm.$t('alerts.basicUpdate'));
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						});
					}
				});
			}
		},
		updateManualPortals() {
			let vm = this;
			this.$APICall('put', 'opportunities/' + this.$route.params.id + '/update-manual-portals', {manualPortals: this.opportunity.manual_portals_display}, (data, success) => {
				if (success) {
					vm.$alert(vm.$t('alerts.manualPortalsUpdate'));
					this.$router.go();
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		deleteImage(key) {
			let vm = this;
			this.$verify(this.$t('alerts.removalQuestion'), (result) => {
				if (result) {
					vm.opportunity.photos.splice(key, 1);
				}
			});
		},
		leftImage(key) {
			let temp = this.opportunity.photos[key];
			this.opportunity.photos[key] = this.opportunity.photos[key - 1];
			this.opportunity.photos[key - 1] = temp;
			this.opportunity.photos = JSON.parse(JSON.stringify(this.opportunity.photos));
		},
		rightImage(key) {
			let temp = this.opportunity.photos[key];
			this.opportunity.photos[key] = this.opportunity.photos[key + 1];
			this.opportunity.photos[key + 1] = temp;
			this.opportunity.photos = JSON.parse(JSON.stringify(this.opportunity.photos));
		},

		openImage(key) {
			this.imageGalleryShow = true;
			this.index = key;
		},
		closeImage() {
			this.imageGalleryShow = false;
		},
		listImages() {
			for (const element of this.opportunity.photos) {
				this.imageList.push(element.link);
			}
		},
		deleteWatermarkedImage(key){
			let vm = this;
			this.$verify(this.$t('alerts.removalQuestion'), (result) => {
				if (result) {
					vm.opportunity.watermarked_photos.splice(key,1);
				}
			});
		},
		leftWatermarkedImage(key) {
			let temp = this.opportunity.watermarked_photos[key];
			this.opportunity.watermarked_photos[key] = this.opportunity.watermarked_photos[key - 1];
			this.opportunity.watermarked_photos[key - 1] = temp;
			this.opportunity.watermarked_photos = JSON.parse(JSON.stringify(this.opportunity.watermarked_photos));
		},
		rightWatermarkedImage(key) {
			let temp = this.opportunity.watermarked_photos[key];
			this.opportunity.watermarked_photos[key] = this.opportunity.watermarked_photos[key + 1];
			this.opportunity.watermarked_photos[key + 1] = temp;
			this.opportunity.watermarked_photos = JSON.parse(JSON.stringify(this.opportunity.watermarked_photos));
		},
		openWatermarkedImage(key){
			this.watermarkedImageGalleryShow = true;
			this.indexWatermarked = key;
		},
		closeWatermarkedImage(){
			this.watermarkedImageGalleryShow = false;
		},
		listWatermarkedImages() {
			for (const element of this.opportunity.watermarked_photos) {
				this.watermarkedImageList.push(element.link);
			}
		},
		generateXml(opportunity, portal){
			let vm = this;
			this.$APICall('get', 'opportunities/xml/' + opportunity + '/' + portal, {}, (data, success) => {
			if (success) {
				if (success) {
					let usableData1 = JSON.parse(JSON.stringify(data['hasErrors']));
					let usableData2 = JSON.parse(JSON.stringify(data['htmlString']));
					vm.hasErrors = usableData1;
					vm.htmlString = usableData2;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}
		});

		},

		validateOpportunity(opportunity, portal){

			let vm = this;
			this.$APICall('get', 'opportunities/xml/' + opportunity + '/' + portal, {}, (data, success) => {

			if (success) {

					let usableData1 = JSON.parse(JSON.stringify(data['hasErrors']));
					let usableData2 = JSON.parse(JSON.stringify(data['htmlString']));
					vm.hasErrors = usableData1;
					vm.htmlString = usableData2;
					vm.$alertHtml(vm.htmlString);
			}
				 else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
		});

		},
		showErrors(htmlString){
			this.$alertHtml(htmlString);
		},

		syncAllPortals(){
			let vm = this;
			this.$APICall('get', 'opportunities/xml/sync-all', {}, (data, success) => {
			if (success) {
				if (success) {
					vm.$notify(vm.$t('alerts.basicUpdate'));
					this.$router.go();
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}
		});

		},
		vtigerLink() {
			window.open(this.vtigerObject.opportunity.vtiger_link, '_blank');
		},
		loadImagesClick(){
			this.loadImagesShow = true;
		},
		loadImagesClose(){
			this.loadImagesShow = false;
		},
		loadImagesSave(){
			if(this.opportunitiesWithImages != null){
				this.$verify(this.$t('alerts.verifyLoadImages1') + '<br><br>' + this.$t('alerts.verifyLoadImages2'), (result) => {
					if (result) {
						this.$APICall('post', 'opportunity-copy-photos-by-id', {from: this.opportunitiesWithImages, to:this.opportunity.id}, (data, success) => {
							if(success){
								this.opportunity.photos = data;
								this.opportunitiesWithImages = [];
								this.imagesLoaded = this.opportunitiesWithImages;
								this.loadImagesClose();
							}
						});
					}
				});
			}
			else{
				this.$alert(this.$t('alerts.noOpportunitySelected'));
			}
		},
		loadImagesClickWatermark(){
			this.loadImagesShowWatermark = true;
		},
		loadImagesCloseWatermark(){
			this.loadImagesShowWatermark = false;
		},
		loadImagesSaveWatermark(){
			if(this.opportunitiesWithImagesWatermark != null){
				this.$verify(this.$t('alerts.verifyLoadImages1') + '<br><br>' + this.$t('alerts.verifyLoadImages2'), (result) => {
					if (result) {
						this.$APICall('post', 'opportunity-copy-photos-by-id-watermark', {from: this.opportunitiesWithImagesWatermark, to:this.opportunity.id}, (data, success) => {
							if(success){
								this.opportunity.watermarked_photos = data;
								this.opportunitiesWithImagesWatermark = [];
								this.imagesLoadedWatermark = this.opportunitiesWithImagesWatermark;
								this.loadImagesCloseWatermark();
							}
						});
					}
				});
			}
			else{
				this.$alert(this.$t('alerts.noOpportunitySelected'));
			}
		},
		loadFeaturesClick(){
			this.loadFeaturesShow = true;
		},
		loadFeaturesClose(){
			this.loadFeaturesShow = false;
		},
		loadFeaturesSave(){
			if(this.opportunitiesWithFeatures != null){
				this.$verify(this.$t('alerts.verifyLoadFeatures1') + '<br><br>' + this.$t('alerts.verifyLoadFeatures2'), (result) => {
					if (result) {
						this.$APICall('post', 'opportunity-get-features-by-id', {id: this.opportunitiesWithFeatures}, (data, success) => {
							if(success){
								console.log(data);
								this.opportunity.luxury = data.luxury;
								this.opportunity.first_row = data.first_row;
								this.opportunity.second_row = data.second_row;
								this.opportunity.seaview = data.seaview;
								this.opportunity.sea_distance = data.sea_distance;
								this.opportunity.center_distance = data.center_distance;
								this.opportunity.sea_approach = data.sea_approach;
								this.opportunity.orientation = data.orientation;
								this.opportunity.hidden_info = data.hidden_info;
								this.opportunity.videocall = data.videocall;
								this.opportunity.exchanges = data.exchanges;
								this.opportunity.appartment_type = data.appartment_type;
								this.opportunity.house_type = data.house_type;
								this.opportunity.space_purpose = data.space_purpose;
								this.opportunity.ground_type = data.ground_type;
								this.opportunity.level_no = data.level_no;
								this.opportunity.position = data.position;
								this.opportunity.ground_purpose = data.ground_purpose;
								this.opportunity.rooms_no = data.rooms_no;
								this.opportunity.room_no = data.room_no;
								this.opportunity.bathrooms_with_no = data.bathrooms_with_no;
								this.opportunity.area = data.area;
								this.opportunity.bathrooms_without_no = data.bathrooms_without_no;
								this.opportunity.ground_length = data.ground_length;
								this.opportunity.toilet_no = data.toilet_no;
								this.opportunity.ground_width = data.ground_width;
								this.opportunity.house_build_type = data.house_build_type;
								this.opportunity.floor = data.floor;
								this.opportunity.total_floors = data.total_floors;
								this.opportunity.ground_area = data.ground_area;
								this.opportunity.units_no = data.units_no;
								this.opportunity.living_area = data.living_area;
								this.opportunity.nett_area = data.nett_area;
								this.opportunity.year_built = data.year_built;
								this.opportunity.build_type = data.build_type;
								this.opportunity.tifacade = data.tifacade;
								this.opportunity.facade_width = data.facade_width;
								this.opportunity.roof_state = data.roof_state;
								this.opportunity.roof_type = data.roof_type;
								this.opportunity.roof_build_type = data.roof_build_type;
								this.opportunity.roof_isolation = data.roof_isolation;
								this.opportunity.windows_type = data.windows_type;
								this.opportunity.windows_equipment = data.windows_equipment;
								this.opportunity.floors = data.floors;
								this.opportunity.approach_material = data.approach_material;
								this.opportunity.approach_type = data.approach_type;
								this.opportunity.renovation_year = data.renovation_year;
								this.opportunity.infrastructure = data.infrastructure;
								this.opportunity.object_data = data.object_data;
								this.opportunity.shape = data.shape;
								this.opportunity.septic_tank_volume = data.septic_tank_volume;
								this.opportunity.septic_tank = data.septic_tank;
								this.opportunity.heating = data.heating;
								this.opportunity.additional_info = data.additional_info;
								this.opportunity.air_conditioning = data.air_conditioning;
								this.opportunity.ground_permits_and_confirmations = data.ground_permits_and_confirmations;
								this.opportunity.energy_class = data.energy_class;
								this.opportunity.alternative_energy = data.alternative_energy;
								this.opportunity.permits_and_confirmations = data.permits_and_confirmations;
								this.opportunity.lodge_terrace = data.lodge_terrace;
								this.opportunity.furniture_state = data.furniture_state;
								this.opportunity.other_objects = data.other_objects;
								this.opportunity.pool_details = data.pool_details;
								this.opportunity.pool_size = data.pool_size;
								this.opportunity.parking_type = data.parking_type;
								this.opportunity.parking_spaces = data.parking_spaces;
								this.opportunity.functionalities = data.functionalities;
								this.opportunity.tourism_income = data.tourism_income;
								this.opportunity.reserve = data.reserve;
								this.opportunity.reserve_amount = data.reserve_amount;
								this.opportunity.longitude = data.longitude;
								this.opportunity.latitude = data.latitude;
								this.opportunity.njuskalo_location = data.njuskalo_location;
								this.opportunity.indomio_location = data.indomio_location;

								this.opportunitiesWithFeatures = null;
								this.loadFeaturesClose();
							}
						});
					}
				});
			}
			else{
				this.$alert(this.$t('alerts.noOpportunitySelected'));
			}
		}
	},
	mounted() {
		let vm = this;
		this.$APICall('get', 'opportunities/vtiger/' + this.$route.params.id, {}, (data, success) => {
			if (success) {
				if (data.opportunity != null) {
					vm.vtigerObject = data;
					vm.$myStore.commit('setBreadcrumbs', [
						{text: this.$t('modules.opportunities'), href: '/#/opportunities', disabled: false},
						{text: this.$route.params.id, href: '/#/opportunities/' + this.$route.params.id, disabled: true}
					]);
					this.$APICall('get', 'opportunities/' + this.$route.params.id, vm.vtigerObject, (data, success2) => {
						if (success2 && data != undefined) {
							let usableData1 = JSON.parse(JSON.stringify(data['opportunity']));
							let usableData2 = JSON.parse(JSON.stringify(data['descriptions']));
							let usableData3 = JSON.parse(JSON.stringify(data['partners']));
							let usableData4 = JSON.parse(JSON.stringify(data['automaticPortals']));
							vm.results = true;
							vm.$nextTick(() => {
								vm.initialLoad = true;
							});
							vm.opportunity = usableData1;
							vm.descriptions = usableData2;
							vm.partners = usableData3;
							vm.automaticPortals = usableData4;
							vm.listImages();
							vm.listWatermarkedImages();
							if (vm.opportunity.category != null && vm.opportunity.category != '') {
								if (vm.opportunity.category.charAt(0) == 'A' ||
									vm.opportunity.category.charAt(0) == 'B' ||
									vm.opportunity.category.charAt(0) == 'H' ||
									vm.opportunity.category.charAt(0) == 'F' ||
									vm.opportunity.category.charAt(0) == 'L') {
									vm.opportunityCategory = vm.opportunity.category.charAt(0);
								}
							}
						} else {
							if (data.internal_message == null || data.internal_message == undefined) {
								this.$APICall('post', 'opportunities/' + this.$route.params.id, vm.vtigerObject, (data, success3) => {
									if (success3) {
										vm.$nextTick(() => {
											this.$APICall('get', 'opportunities/' + this.$route.params.id, vm.vtigerObject, (data, success4) => {
												if (success4) {

													let usableData1 = JSON.parse(JSON.stringify(data['opportunity']));
													let usableData2 = JSON.parse(JSON.stringify(data['descriptions']));
													let usableData3 = JSON.parse(JSON.stringify(data['partners']));
													let usableData4 = JSON.parse(JSON.stringify(data['automaticPortals']));
													vm.results = true;
													vm.$nextTick(() => {
														vm.initialLoad = true;
													});
													vm.opportunity = usableData1;
													vm.descriptions = usableData2;
													vm.partners = usableData3;
													vm.automaticPortals = usableData4;
													vm.listImages();
													vm.listWatermarkedImages();
													if (vm.opportunity.category != null && vm.opportunity.category != '') {
														if (vm.opportunity.category.charAt(0) == 'A' ||
															vm.opportunity.category.charAt(0) == 'B' ||
															vm.opportunity.category.charAt(0) == 'H' ||
															vm.opportunity.category.charAt(0) == 'F' ||
															vm.opportunity.category.charAt(0) == 'L') {
															vm.opportunityCategory = vm.opportunity.category.charAt(0);
														}
													}
												} else {
													if (data.internal_message == 'Opportunity does not have a realestate category') {
														vm.results = false;
													}
													else{
														vm.$alert(vm.$t('alerts.basicError'));
													}
												}
											});
										});
									} else {
										vm.$alert(vm.$t('alerts.basicError'));
									}
								});
							}
							else {
								if (data.internal_message == 'Opportunity does not have a realestate category') {
									vm.results = false;
								}
								else{
									vm.$alert(vm.$t('alerts.basicError'));
								}
							}
						}
					});
				} else {
					vm.results = false;
				}
			} else {
				vm.results = false;
			}
		});
		this.$APICall('get', 'select/languages', {}, (data, success) => {
			if (success) {
				let usableData = JSON.parse(JSON.stringify(data));
				vm.languages = usableData;
			}
		});
	}
}
</script>

<style scoped>
.files-container {
	margin: 5px;
	padding: 5px;
	border: 1px solid rgb(206, 206, 206);
	border-radius: 3px;
	min-height: 130px;
	max-height: 250px;
	overflow-x: auto;
}

.file-tile {
	margin: 2px;
	padding: 2px;
	height: 180px;
	width: 120px;
	text-align: center;
	display: inline-block;
	overflow: hidden;
	word-wrap: break-word;
}

.file-tile:hover {
	background-color: rgb(240, 240, 240);
}

.tile-image {
	margin: 2px;
	padding: 2px;
	height: 100px;
	width: 116px;
	overflow: hidden;
}

.tile-image:hover {
	cursor: pointer;
}

.tile-text {
	margin: 2px;
	padding: 2px;
	height: 30px;
	width: 116px;
	font-size: 10px;
	overflow: hidden;
}

.tile-buttons {
	margin: 2px;
	padding: 2px;
	height: 18px;
	width: 116px;
}

.tile-buttons i {
	font-size: 20px !important;
}

.tile-buttons button {
	width: 20px;
	height: 14px;
}

.table {
	font-family: Helvetica, sans-serif;
	font-size: 13px;
	border-collapse: collapse;
	border-radius: 6px;
	width: 100%;
	text-align: center;
	overflow: hidden;
	background-color: #ffffff;
	color: rgb(34, 34, 34);
}

.table td, .table th {
	padding: 6px;
}

.table th {
	font-size: 15px;
	font-weight: bold;
	padding-top: 8px;
	padding-bottom: 8px;
	background-color: #cacaca;
	opacity: 0.9;
}

.table tr:nth-child(even) {
	background-color: #e8e8e8;
}

.table td:first-child {
	text-align: center;
}

.table tr:hover {
	background-color: #ddd;
}

.website-error {
	color: rgb(131, 10, 10);
}

.sticky-items {
	position: -webkit-sticky;
    position: sticky;
    top: 64px;
    z-index: 200;
	background: #fafafa;
	box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.09);
}

.clear-button{
	color:#949494;
	text-decoration: underline;
}

.load-images-popup{
	min-height:200px;
}
</style>
